export const backEndLink = 'https://faces-backend.wowmaking.net/';
